import React, { PureComponent } from 'react'
import './styles.scss'
import { Link } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { userActions } from '../../../redux/actions/user'
import PropTypes from 'prop-types'
import Layer from '../../Shared/Layer'
import Icon from '../../Shared/Icon'
import { Hidden, Visible } from '../../Shared/Grid'

class Header extends PureComponent {
  state = {
    showContactUsLayer: false
  }

  render () {
    const { t } = this.props
    const navLinks = <nav className="mygiata_top_navi">
      <ul className="mygiata_top_navi_links">
        {this.props.loggedIn ? <li>
          <span className={'Link'} onClick={this.props.logout}>{t('LOGOUT')}</span>
        </li> : null}
      </ul>
    </nav>

    return (
      <header className="mygiata_header">
        <div className="mygiata_header_top">
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', flex: 1 }}>
              <Link to="/admin" className="mygiata_logo"/>
            </div>
            {this.props.property &&
            <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
              <h3>{this.props.property.name}</h3>
              <h5>{this.props.property.city.name + ' | ' + this.props.property.destination.name + ' | ' + this.props.property.country.name}</h5>
            </div>
            }
            {
              this.props.property ?
                <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }}>
                  <Hidden xs sm md>
                    {navLinks}
                  </Hidden>
                </div>
                :
                <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }}>
                  {navLinks}
                </div>
            }
          </div>
          {this.props.property &&
          <Visible xs sm md>
            <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
              {navLinks}
            </div>
          </Visible>
          }
          <div></div>
        </div>
        {this.state.showContactUsLayer &&
        <Layer type="center" size="small" id={'contact-us-layer'}
               show={true}
               onHideClick={() => this.setState({ showContactUsLayer: false })}>
          <div>
            <h2>{t('CONTACT_US')}</h2>
            <div>
              Please do not hesitate to contact the GIATA Hotel Content Team for assistance at any time.
              Outside our general office hours between Monday and Friday from 7 a.m. and 7 p.m CET,
              please leave your details for us to respond to your enquiry as soon as possible.
            </div>
            <div className="list">
              <div className="entry">
                <div className="entry-image">
                  <a href="mailto:hotels@giata.com">
                    <Icon type={'envelope'}/>
                  </a>
                </div>
                <div className="entry-value">
                  <a href="mailto:hotels@giata.com">hotels@giata.com</a></div>
              </div>
              <div className="entry">
                <div className="entry-image">
                  <a href="tel:+493042026555">
                    <Icon type={'phone'}/>
                  </a>
                </div>
                <div className="entry-value"><a href="tel:+493042026555">+49 30 420 265 55</a></div>
              </div>
            </div>
          </div>
        </Layer>
        }
      </header>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    loggedIn: !!state.user.loggedIn,
  }
}

const mapDispatchToProps = {
  logout: userActions.logout
}

Header.propTypes = {
  property: PropTypes.object,
  loggedIn: PropTypes.bool.isRequired,
  logout: PropTypes.func.isRequired
}
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Header))
